function AdminApp() {
  return (
    <main className="grid min-h-screen place-items-center p-6">
      <section className="w-full max-w-[560px] rounded-2xl border border-gray-200 bg-white p-7">
        <h1 className="m-0 text-2xl font-semibold">관리자 영역 준비 중</h1>
        <p className="mt-3 leading-relaxed text-gray-600">
          현재는 사용자 로그인 플로우를 우선 구현했습니다. 추후 이 영역에 관리자 기능을
          추가하면 됩니다.
        </p>
      </section>
    </main>
  );
}

export default AdminApp;
